import { Utils } from "services";
import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  GiftedChat,
  InputToolbar,
  Composer,
  Bubble,
  Send,
  Time,
  message, Avatar
} from "react-web-gifted-chat";
import Chat from "./chat";
import { connect } from "react-redux";
import {
  addChat,
  getChatMasterAdmin,
  postCareChat,
  sentCareImag,
  sentCareMsg,
  setDate,
  setName,
  setNewChats,
  updateChats,
} from "actions/adminCare";
import { IMG_URL } from "../../env.json";
import {
  getCareChat,
  getConversationOpenedClosedUsersFunction,
  postCareSendImg,
  closeCoversation,
  setCloseOrOpenConversation,
  loadEarlierMsg,
  postCareUserChat,
  setRole,
  setBatch,
} from "actions/adminCare";
import EmptyChatScreen from "./emptyChatScreen";
import PageDataLoader from "components/pageDataLoader";
import PreviewModal from "./previewModal";
import image1 from "../../Assets/care/Icon material-send.svg";
import image2 from "../../Assets/care/CheckCircle (2).svg";
import image3 from "../../Assets/care/Icon awesome-image.svg";
import image4 from "../../Assets/care/Group 9552.svg";
import { v4 as uuidv4 } from 'uuid';
import { Notification } from "services";

import {
  CheckCircleOutlined,
  FileImageFilled,
  RedoOutlined,
} from "@ant-design/icons";
import { stringify } from "uuid";
var chat;

function parseData(data) {
  if (!data) return {};
  if (typeof data === "object") return data;
  if (typeof data === "string") return JSON.parse(data);

  return {};
}

export const handler = (msg, type, targetId, oldChats, user) => {
  console.log('in handler', msg, type, targetId)
  // myChat(msg);
  console.log('msg', msg)
  console.log('in handler')
  chat.sendmsg({
    message: msg,
    createdAt: new Date(),
    oldChats: oldChats,
    targetId: targetId,
    user: user,
    type: type

  }
    , type, targetId.toString());
  // console.log(chat);
};

const CustomInputToolbar = ({
  msg,
  setmsg,
  onButtonClick,
  handleCustomSend,
  handleClearInput,
  studentChat,
  userStatus,
  handleClose,
  showCloseButton,
  user
}) => {
  const isSuperAdminOrSupport = user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('InstituteSupport');
  const isInputDisabled = isSuperAdminOrSupport && userStatus === "closed";
  const isSendDisabled = isInputDisabled || !msg || msg.trim() === "";

  return (
    <div style={{
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "98%",
      marginLeft: "1%",
      marginRight: "1%",
      position: "absolute",
      bottom: "16px",
      zIndex: 10,
      backgroundColor: "transparent",
    }}>
      {/* Capsule input container */}
      <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        backgroundColor: isInputDisabled ? "#f5f5f5" : "#ffffff",
        borderRadius: "30px",
        padding: "6px 16px",
        flex: 1,
        marginRight: showCloseButton ? "12px" : "0px",
        position: "relative",
        border: "1px solid #d9d9d9",
        boxShadow: "0px 2px 8px rgba(0,0,0,0.06)",
        height: "56px",
        opacity: isInputDisabled ? 0.7 : 1,
        cursor: isInputDisabled ? "not-allowed" : "default"
      }}>
        {/* File attachment icon */}
        <div 
          onClick={isInputDisabled ? undefined : onButtonClick} 
          style={{ 
            cursor: isInputDisabled ? "not-allowed" : "pointer", 
            marginRight: "12px", 
            display: "flex", 
            alignItems: "center",
            opacity: isInputDisabled ? 0.5 : 1
          }}
        >
          <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13 2H4C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H18C19.1046 22 20 21.1046 20 20V9H13V2Z" fill="#1089ff" />
            <path d="M13 2V9H20L13 2Z" fill="#0c6ecf" />
            <circle cx="8" cy="13" r="2" fill="white" />
            <path d="M5 19L9 14L12 17L15 13L18 19H5Z" fill="white" />
          </svg>
        </div>

        {/* Text input */}
        <input
          type="text"
          placeholder={isInputDisabled ? "Conversation is closed" : "Start typing..."}
          value={msg}
          disabled={isInputDisabled}
          onChange={(e) => setmsg(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              if (!isSendDisabled) handleCustomSend();
            }
          }}
          style={{
            flex: 1,
            background: isInputDisabled ? '#f5f5f5' : '#ffffff',
            border: 'none',
            padding: '8px 4px',
            color: '#000000',
            outline: 'none',
            fontSize: '14px',
            fontFamily: 'Roboto, sans-serif',
            height: "38px",
            cursor: isInputDisabled ? "not-allowed" : "text"
          }}
        />

        {/* Send button */}
        <div 
          onClick={isSendDisabled ? undefined : handleCustomSend} 
          style={{ 
            cursor: isSendDisabled ? "not-allowed" : "pointer", 
            display: "flex", 
            alignItems: "center", 
            marginLeft: "12px",
            opacity: isSendDisabled ? 0.5 : 1
          }}
        >
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M22 2L11 13M22 2L15 22L11 13M11 13L2 9L22 2" stroke="#b042ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
      </div>

      {/* Close Conversation Button */}
      {showCloseButton && (
        <div style={{ display: "flex", alignItems: "center", width: "fit-content", flexShrink: 0 }}>
          {userStatus === "opened" ? (
            <div onClick={handleClose} style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#1089ff" />
                <path d="M8.5 12.5L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span style={{ color: "#1089ff", fontWeight: 600, fontSize: "14px", fontFamily: "Roboto, sans-serif", letterSpacing: "0.5px" }}>
                CLOSE CONVERSATION
              </span>
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "default", opacity: 0.6 }}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="grey" />
                <path d="M8.5 12.5L11 15L16 9" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
              </svg>
              <span style={{ color: "grey", fontWeight: 600, fontSize: "14px", fontFamily: "Roboto, sans-serif", letterSpacing: "0.5px" }}>
                CLOSE CONVERSATION
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

function ChatScreen({
  isAulasChat,

  getConversationOpenedClosedUsersFunction,
  currentPage,
  batch,
  role,
  date,
  name,
  user,
  chats,
  setDate,
  setName,
  getCareChat,
  addChat,
  postCareSendImg,
  postCareChat,
  postCareUserChat,
  setCloseOrOpenConversation,
  isClosedOrOpened,
  specificStudentId,
  studentChat,
  pageLoader,
  setRole,
  setBatch,
  disableLoadEarlier,
  togglePageLoader,
  sentCareMsg,
  chatWithAulas,
  getChatMasterAdmin,
  sentCareImag,
  widthForCard,
  admin,
  setNewChats,
  new_Chats,
  openCloseConversationListWithChat,
  updateChats
}) {
  { console.log("AA-chats", openCloseConversationListWithChat) }

  var curPage = currentPage;
  const [fileInputValue, setfileInputValue] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [loadEarlier, toggleLoadEarlier] = useState(false);
  const inputFile = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [new_chats, setNew_chats] = useState([]);
  const [userStatus, setUserStatus] = useState("opened");
  const [msg, setmsg] = useState("");
  const [socketMsg, setSocketMsg] = useState([])

  useEffect(() => {
    console.log('temp in useeffect', new_Chats)
    if (new_Chats?.length) {
      setSocketMsg([...new_Chats])
    }
  }, [new_Chats])


  const getMasterChats = (e, temp) => {
    console.log('master chat')
    if (e.data.data?.sendByMaster && e.data.data.destinationUserId == user.id) {
      setNewChats([...temp])
      updateChats([...temp])
    }
  }

  const callback = (e) => {
    console.log(e);
    switch (e.action) {
      case "rcvChat":
        console.log('socket get chat', e.data)
        let temp = e.data.data.oldChats && e.data.data.oldChats?.length != 0 ? [...e?.data?.data?.oldChats] : [];

        let userObj = {
          id: e.data.user?.id,
          name: e.data.user?.name,
          // avatar:`${IMG_URL}/${(e.data.user?.image)}` modified after naster admin req
          avatar: `${IMG_URL}/${(e.data.user?.image)}`
        }

        if (e.data.data.sendByMaster) {
          userObj['avatar'] = `${IMG_URL}/${(e.data.data.user?.image)}`
        }


        let obj = {
          id: uuidv4(),
          createdAt: e.data.data.createdAt,
          userId: userObj?.id,
          user: userObj
        }
        if (e.data.type == 'Image') {
          obj['image'] = `${IMG_URL}/${(e.data.data.message)}`;
        } else {
          obj['text'] = e.data.data.message;
        }

        temp.unshift(obj);
        console.log('temp', temp)

        if (studentChat == true) {
          if (chatWithAulas === true) {
            console.log('master 1')
            // if(e.data.data?.sendByMaster)
            // setNewChats([...temp])
            getMasterChats(e, temp)

          } else {
            console.log('master 2')

            if (userObj?.id != user?.id) {
              setNewChats([...temp])
              updateChats([...temp])

            }
          }
        } else {
          console.log('master 3')

          if (userObj?.id != user?.id && userObj?.id == specificStudentId) {
            setNewChats([...temp])
            updateChats([...temp])

          }
        }

        console.log('sock', temp)

        // newChatRcv(e.data);
        break;
      case "connected":
        chat.listen();
        break;
      case "joinRcv":
        // connected
        console.log('joinRcv connected')
        break;
      case "pong":
        // connected
        console.log('pong')
        break;
      case "privateChatRcv":
        break;

      // console.log("userList", e.data);
    }
  };

  const socketConnection = () => {
    //     console.log('connection params',user,
    //     user?.id.toString(),
    //     user?.name,
    //     (user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes('InstituteSupport') || user?.privilage?.includes('Admin'))? user?.orgId.toString():user?.id.toString(),
    // )
    chat = new Chat({
      user: user,
      userId: user?.id?.toString(),
      userName: user?.name,
      orgId: (user?.privilage?.includes("SuperAdmin") || user?.privilage?.includes('InstituteSupport') || user?.privilage?.includes('Admin')) ? user?.orgId?.toString() : user?.id?.toString(),


      callback,
    });

    chat.initsocket();

    // console.log(chat);
  };



  useEffect(() => {
    setNewChats([])
    socketConnection()
    return () => {
      chat.close();
      setNewChats([])

    }
  }, [specificStudentId])
  useEffect(() => {
    for (let i = 0; i < openCloseConversationListWithChat?.onlyClose?.length; i++) {
      if (openCloseConversationListWithChat?.onlyClose?.[i]?.userId == specificStudentId) {
        setUserStatus("closed")
        console.log("closed")
      }
    }
    for (let i = 0; i < openCloseConversationListWithChat?.onlyOpen?.length; i++) {
      if (openCloseConversationListWithChat?.onlyOpen?.[i]?.userId == specificStudentId) {
        setUserStatus("opened")
        console.log("opened")
      }
    }
  }, [specificStudentId, openCloseConversationListWithChat])
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    sendfile(imageUrl);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const onButtonClick = () => {
    inputFile.current.click();
  };

  // const onChangeFile = (e) => {
  //   e.preventDefault();
  //   const file = e.target.files[0];
  //   // var blob=new Blob([file])

  //   if (file != undefined) {
  //     const imgUrl = URL.createObjectURL(file);
  //     setfileInputValue(file);
  //     setImageUrl(imgUrl);

  //     showModal();
  //   }
  // };
  const onChangeFile = (e) => {
    e.preventDefault();
    const file = e.target.files[0];

    if (!file) return;

    // Validate image type
    if (!file.type.startsWith("image/")) {
      Notification.error("Please upload a valid image file.");
      e.target.value = "";
      return;
    }

    const imgUrl = URL.createObjectURL(file);
    setfileInputValue(file);
    setImageUrl(imgUrl);

    showModal();
  };
  const handleClose = () => {
    postCareChat(
      specificStudentId,
      "Closed",
      "Line",
      1,
      batch,
      role,
      date,
      name
    );
    setCloseOrOpenConversation(false);
  };

  const handleOpen = () => {
    setCloseOrOpenConversation(true);
  };

  const handleImageSend = () => {
    if (imageUrl != "") {
      const obj = {
        image: imageUrl,
        createdAt: new Date(),
        user,
      };
      // sendfile(obj.image);

      if (studentChat == true) {
        if (chatWithAulas === true) {
          // console.log("chats after image")
        } else {
          getCareChat();
        }
      } else {
        getConversationOpenedClosedUsersFunction(
          curPage,
          batch,
          role,
          date,
          name,
          specificStudentId
        );
      }

      setImageUrl("");
    }
  };

  useEffect(() => {
    togglePageLoader(true);
    if (studentChat == true) {
      // console.log("studentssss")
      if (chatWithAulas === true) {
        // console.log('inisial chats')
        getChatMasterAdmin(() => togglePageLoader(false));
      } else {
        getCareChat(1, () => togglePageLoader(false));
      }
    } else {
      getConversationOpenedClosedUsersFunction(
        curPage,
        batch,
        role,
        date,
        name,
        specificStudentId,
        () => togglePageLoader(false)
      );
    }

    return () => { };
  }, [role, batch, specificStudentId]);

  const handleCustomSend = () => {
    if (msg && msg.trim() !== "") {
      onSend([{
        text: msg.trim(),
        user: user,
        createdAt: new Date()
      }]);
      setmsg("");
    }
  };

  const handleClearInput = () => {
    setmsg("");
    setfileInputValue("");
    setImageUrl("");
  };

  const onSend = useCallback((messages = []) => {


    if (messages[0].text !== "") {
      addChat(
        Utils.sendMessage(
          messages[0].text,
          messages[0].user,
          {},
          messages[0].createdAt
        )
      );
      if (studentChat == true) {
        if (chatWithAulas === true) {
          // console.log('postcareChat')
          handler(messages[0].text, 'text', '1234', new_Chats, user)
          sentCareMsg(messages[0].text);

        } else {
          handler(messages[0].text, 'text', user?.orgId, new_Chats, user)
          postCareUserChat(messages[0].text, "Text");
        }
      } else {
        handler(messages[0].text, 'text', specificStudentId, new_Chats, user)
        postCareChat(
          specificStudentId,
          messages[0].text,
          "Text",
          1,
          batch,
          role,
          date,
          name
        );
      }
    }
  });

  function sendfile(image) {
    if (studentChat == true) {
      if (chatWithAulas == true) {
        // console.log("image send")
        // handler(fileInputValue,"Image",'1234')
        sentCareImag(fileInputValue, (url) => { handler(url, "Image", '1234', new_Chats, user) });
      } else {
        // handler(fileInputValue,"Image",user?.orgId)
        postCareSendImg(fileInputValue, parseInt(user.id), 0, (url) => { handler(url, "Image", user?.orgId, new_Chats, user) });
      }
    } else {
      // handler(fileInputValue,"Image",specificStudentId)
      //   postCareSendImg(
      //   fileInputValue,
      //   parseInt(specificStudentId),
      //   1,
      //   1,
      //   batch,
      //   role,
      //   date,
      //   name
      // );
      postCareSendImg(
        fileInputValue,
        parseInt(specificStudentId),
        1,
        (url) => { handler(url, "Image", specificStudentId, new_Chats, user) }
      );
    }
    addChat(Utils.sendMessage("", user, { image }, new Date()));

    setfileInputValue("");
  }
  function renderBubble(props) {
    return (
      <Bubble
        {...props}
        selectable={true}
        wrapperStyle={{
          right: {
            backgroundColor: "white",
            padding: 6,
            borderRadius: 8,
            elevation: 2,
            borderColor: "#E6E6E6",
            borderWidth: 1,
          },
          left: {
            backgroundColor: "white",
            padding: 6,
            borderRadius: 8,
            elevation: 2,
            borderColor: "#E6E6E6",
            borderWidth: 1,
          },
        }}
        linkStyle={{
          right: { color: "blue" },
          left: { color: "blue" },
        }}
        textStyle={{
          right: {
            color: "#191919",
            fontSize: 14,
            lineHeight: 22,
            fontFamily: "Roboto",
          },
          left: {
            color: "#191919",
            fontSize: 14,
            lineHeight: 22,
            fontFamily: "Roboto",
          },
        }}
      />
    );
  }

  function renderTime(props) {
    return (
      <Time
        {...props}
        textStyle={{
          right: {
            color: "grey",
          },
          left: {
            color: "grey",
          },
        }}
      />
    );
  }

  function renderSend(props) {
    const isDisabled = !props.text || props.text.trim() === "";
    return (
      <Send
        {...props}
        alwaysShowSend
        disabled={isDisabled}
        containerStyle={{
          width: "10%",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          opacity: isDisabled ? 0.5 : 1,
          cursor: isDisabled ? "not-allowed" : "pointer",
        }}
      >
        <div style={{ marginBottom: 10, marginTop: "10px", marginRight: 10 }}>
          <img
            style={{ width: "30px", opacity: isDisabled ? 0.5 : 1, }}
            onClick={handleImageSend}
            src={image1}
          />
        </div>
      </Send>
    );
  }

  const onLoadEarlier = () => {
    toggleLoadEarlier(true);
    curPage = curPage + 1;
    if (studentChat == true) {
      if (chatWithAulas === true) {
        getChatMasterAdmin(() => toggleLoadEarlier(false), curPage);
      } else {
        getCareChat(curPage, () => toggleLoadEarlier(false));
      }
    } else {
      getConversationOpenedClosedUsersFunction(
        curPage,
        batch,
        role,
        date,
        name,
        specificStudentId,
        () => toggleLoadEarlier(false)
      );
    }
  };
  const renderInputToolbar = () => (
    <CustomInputToolbar
      msg={msg}
      setmsg={setmsg}
      onButtonClick={onButtonClick}
      handleCustomSend={handleCustomSend}
      handleClearInput={handleClearInput}
      studentChat={studentChat}
      userStatus={userStatus}
      handleClose={handleClose}
      showCloseButton={studentChat !== true && (user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('InstituteSupport'))}
      user={user}
    />
  );

  function renderSystemMessage() {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          flexDirection: "row",
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          marginTop: "5px",
          marginBottom: "5px",
        }}
      >
        <div
          style={{
            width: "30%",
            borderBottom: "solid",
            marginLeft: "5%",
            borderColor: "#594099",
            marginRight: "5px",
          }}
        ></div>
        <img style={{ marginLeft: "1px" }} src={image2} />
        <p
          style={{
            fontSize: 12,
            fontFamily: "Roboto",
            fontWeight: "bold",
            color: "#594099",
            marginLeft: "10px",
          }}
        >
          CONVERSATION CLOSED
        </p>
        <div
          style={{
            width: "30%",
            borderBottom: "solid",
            marginRight: "5%",
            borderColor: "#594099",
          }}
        ></div>
      </div>
    );
  }
  let string = "Type a message...";
  if (studentChat == true) {
    string = "Type your question here...";
  }
  // let chatUser;
  useEffect(() => {
    setNewChats([])

    const newchats = chats?.map((item, index) => {
      const chatItem = { ...item };
      { console.log(chatItem, "chat detail") }

      if (item?.type == "Text") {
        chatItem["text"] = item?.message;
      }
      if (item?.type == "Image") {
        chatItem["image"] = `${IMG_URL}/${item?.message}`;
      }
      if (item?.type == "Line") {
        chatItem["system"] = "true";
        closeCoversation(true);
      }

      if (chatWithAulas === true) {
        let myObjStr = JSON.stringify(item.user);
        chatItem["user"] = {
          name: parseData(item.user).name,
          id: parseData(item.user).id,
          avatar: `${IMG_URL}/${parseData(item.user).avatar}`,
        };
      } else {
        chatItem["user"] = {
          name: parseData(item.user).name,
          id: parseData(item.user).id,
          avatar: `${IMG_URL}/${parseData(item.user).image}`,
        };
      }

      chatItem["key"] = index;
      return chatItem;
    });
    setNewChats(newchats);
    return () => {
      setNewChats([])
    }

  }, [chats]);
  const renderAvatar = (props) => (
    <Avatar
      {...props}
      imageStyle={{
        left: {
          cursor: "default",
        },
        right: {
          cursor: "default",
        },
      }}
    />
  );
  const chatBox = (
    <>
      <div className="custom-gifted-chat-scroll-container" style={{ flex: 1, display: "flex", flexDirection: "column", height: "100%", position: "relative" }}>
        <GiftedChat
          renderChatEmpty={EmptyChatScreen}
          alignTop={true}
          onLongPress={() => { }}
          placeholder={string}
          selectable={true}
          renderInputToolbar={renderInputToolbar}
          renderBubble={renderBubble}
          showUserAvatar={true}
          renderAvatar={renderAvatar}
          renderSend={renderSend}
          renderTime={renderTime}
          onLoadEarlier={onLoadEarlier}
          isLoadingEarlier={loadEarlier}
          renderSystemMessage={renderSystemMessage}
          loadEarlier={!disableLoadEarlier}
          messages={pageLoader ? [] : new_Chats}
          onSend={(messages) => onSend(messages)}
          bottomOffset={80}
          renderFooter={() => <div style={{ height: "80px", minHeight: "80px", flexShrink: 0 }} />}
          renderComposer={(props1) => (
            <Composer
              {...props1}
              textInputStyle={{
                color: "grey",
                width: "90%",
                height: "40px",
                minHeight: "100",
              }}
            />
          )}
          user={user}
        />
      </div>
      <input
        type="file"
        id="file"
        ref={inputFile}
        onChange={(e) => {
          onChangeFile(e);
        }}
        value={""}
        style={{ display: "none" }}
        accept="image/*"
      />
      <PreviewModal
        sendfile={sendfile}
        image={imageUrl}
        isModalVisible={isModalVisible}
        showModal={showModal}
        handleOk={handleOk}
        handleCancel={handleCancel}
      />
    </>
  );

  return (
    <div style={{ height: "100%", width: "100%", display: "flex", flexDirection: "column", paddingTop: "0px", position: "relative" }}>
      <style>{`
        .custom-gifted-chat-scroll-container > div > div:first-child {
          height: calc(100% - 80px) !important;
        }
        .custom-gifted-chat-scroll-container,
        .custom-gifted-chat-scroll-container * {
          scrollbar-width: none !important;
          -ms-overflow-style: none !important;
        }
        .custom-gifted-chat-scroll-container::-webkit-scrollbar,
        .custom-gifted-chat-scroll-container *::-webkit-scrollbar {
          display: none !important;
        }
      `}</style>
      {console.log("newChats", new_Chats)}

      {new_Chats?.length === 0 ? (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: widthForCard ? "50%" : "80%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <EmptyChatScreen adimin={admin} />
        </div>
      ) :
        null
      }
      {
        user?.privilage?.includes("SuperAdmin") ? (
          <>
            {isAulasChat
              ? chatBox
              : specificStudentId && chatBox
            }
          </>
        ) : (
          <>
            {chatBox}
          </>
        )
      }

      <PageDataLoader visible={pageLoader} />
    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    chats,
    currentPage,
    openCloseConversationListWithChat,
    batch,
    role,
    date,
    name,
    isClosedOrOpened,
    specificStudentId,
    disableLoadEarlier,
    chatWithAulas,
    new_Chats,
  } = state.adminCare;
  const { user } = state.session;
  return {
    chats,
    user,
    currentPage,
    openCloseConversationListWithChat,
    batch,
    role,
    date,
    name,
    isClosedOrOpened,
    specificStudentId,
    disableLoadEarlier,
    chatWithAulas,
    new_Chats,
  };
};

const mapDispatchToProps = (dispatch) => ({
  addChat: (m) => dispatch(addChat(m)),
  postCareChat: (
    specificStudentId,
    message,
    type,
    page,
    batch,
    role,
    date,
    name,
    userId
  ) =>
    dispatch(
      postCareChat(
        specificStudentId,
        message,
        type,
        page,
        batch,
        role,
        date,
        name,
        userId
      )
    ),
  postCareSendImg: (file, specificStudentId, adminId, callback) =>
    dispatch(postCareSendImg(file, specificStudentId, adminId, callback)),
  postCareUserChat: (message, type) =>
    dispatch(postCareUserChat(message, type)),
  getCareChat: (page, callback) => dispatch(getCareChat(page, callback)),
  closeCoversation: () => dispatch(closeCoversation()),
  setCloseOrOpenConversation: (m) => dispatch(setCloseOrOpenConversation(m)),
  loadEarlierMsg: (m) => dispatch(loadEarlierMsg(m)),
  setName: (m) => dispatch(setName(m)),
  setDate: (m) => dispatch(setDate(m)),
  setRole: (m) => dispatch(setRole(m)),
  setBatch: (m) => dispatch(setBatch(m)),
  sentCareMsg: (m) => dispatch(sentCareMsg(m)),
  getChatMasterAdmin: (callback, curPage) =>
    dispatch(getChatMasterAdmin(callback, curPage)),
  sentCareImag: (file, callback) => dispatch(sentCareImag(file, callback)),
  getConversationOpenedClosedUsersFunction: (
    curPage,
    batch,
    role,
    date,
    name,
    specificStudentId,
    callback,

  ) =>
    dispatch(
      getConversationOpenedClosedUsersFunction(
        curPage,
        batch,
        role,
        date,
        name,
        specificStudentId,
        callback
      )
    ),
  setNewChats: (chats) => dispatch(setNewChats(chats)),
  updateChats: (chats) => dispatch(updateChats(chats))
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatScreen);
